// @ts-nocheck

import { createSelector } from 'reselect';

import { selectKLUserOrientation } from '../user';

const getStepIdFromProps = (_, { stepId }) => stepId;
const getProgressIndexFromProps = (_, { progressIndex }) => progressIndex;

const selectCurrentOrientationStep = createSelector(
  [getStepIdFromProps, getProgressIndexFromProps, selectKLUserOrientation],
  (stepId, progressIndex, orientation) => orientation[progressIndex]?.[stepId],
);

const selectOrientationStepStatus = createSelector(
  [selectCurrentOrientationStep],
  (orientationStep) => orientationStep?.status,
);

const selectOrientationStepBetslipReference = createSelector(
  [selectCurrentOrientationStep],
  (orientationStep) => orientationStep?.betslipReference,
);

const selectKLOrientationStepDetailsProps = createSelector(
  [getStepIdFromProps, getProgressIndexFromProps, selectOrientationStepStatus, selectOrientationStepBetslipReference],
  (stepId, progressIndex, status, betslipReference) => ({
    stepId,
    progressIndex,
    status,
    betslipReference,
  }),
);

export default selectKLOrientationStepDetailsProps;
